import React, { Component } from 'react';
import { ApiResponseHelper, connect, Icon } from 'omni-common-ui';
import { bindActionCreators } from 'redux';
import {
  actions as attendanceActions,
  accessors as attendanceAccessors,
} from 'data/AttendanceHistory';
import { actions as groupActions } from 'containers/Group';
import { TableView, TableViewTr, NormalTd, TextTd } from 'components/TableView';
import is from 'is_js';
import PropTypes from 'prop-types';

import styles from './style.postcss';

const TABLE_FILTER_DEFAULT = {
  pageSize: 10,
  pageNumber: 1,
};

export class AttendanceHistory extends Component {
  constructor(props) {
    super(props);
    this.state = { tableFilter: {} };
    this._onTableFilterChange = this._onTableFilterChange.bind(this);
  }

  componentDidMount() {
    const { pageSize, pageNumber } = this.props.location.query;
    const hasQuery = ! (is.undefined(pageSize) || is.undefined(pageNumber));
    const tableFilter = hasQuery ?
      this.props.location.query :
      this.state.tableFilter;
    this._onTableFilterChange(tableFilter);
  }

  componentWillUpdate(nextProps, nextState) {
    if (nextState.tableFilter === this.state.tableFilter) {
      return;
    }

    this._fetchHistory(nextProps, nextState.tableFilter);
  }

  _fetchHistory(props, tableFilter) {
    this.props.fetchAttendanceHistory({ ...tableFilter, groupId: props.groupId });
    this.props.router.replace(Object.assign({},
      this.props.location,
      { query: tableFilter }));
  }

  _onTableFilterChange(tableFilter) {
    if (! (tableFilter.pageNumber && tableFilter.pageSize)) {
      this.setState({ tableFilter: TABLE_FILTER_DEFAULT });
    } else {
      this.setState({ tableFilter });
    }
  }

  _renderTableRow(row) {
    return <TableViewTr>
      <TextTd text={row.action} />
      <TextTd text={row.studentName} />
      <NormalTd>{row.sessionDuration}</NormalTd>
      <TextTd text={row.previousStatus} />
      <TextTd text={row.currentStatus} />
      <TextTd text={row.editedByName} />
      <NormalTd>{row.actionTime}</NormalTd>
    </TableViewTr>;
  }

  render() {
    const { attendanceHistory } = this.props;
    if (! attendanceHistory) {
      return null;
    }

    const dateTimeHeader = <div className={styles.AttendanceHistory_table_dateTimeHeader}>
      <span>Date & Time</span>
      <Icon id="sorting" />
    </div>;
    const headers = [{ key: 'action', text: 'Action', sortable: false },
      { key: 'studentName', text: 'Student', sortable: false },
      { key: 'sessionDuration', text: 'Session', sortable: false },
      { key: 'previousStatus', text: 'Before', sortable: false },
      { key: 'currentStatus', text: 'After', sortable: false },
      { key: 'editedByName', text: 'Edit By', sortable: false },
      { key: 'actionTime', text: dateTimeHeader, sortable: false }];

    return <div className={styles.AttendanceHistory}>
      <TableView source={attendanceHistory.studentAttendanceHistories}
          headers={headers}
          pageable
          tableTitle="Change Logs"
          renderTableRow={(row) => this._renderTableRow(row)}
          noResultsString="No results yet."
          query={this.state.tableFilter}
          totalRecords={attendanceHistory.totalRecords}
          onFilterChange={this._onTableFilterChange} />
    </div>;
  }
}

AttendanceHistory.propTypes = {
  attendanceHistory: PropTypes.object,
  fetchAttendanceHistory: PropTypes.func,
  groupId: PropTypes.number,
  location: PropTypes.object,
  replace: PropTypes.func,
  router: PropTypes.object,
  timeZone: PropTypes.string,
};

export function mapStateToProps(state, ownProps) {
  const groupId = ownProps.params.groupId;
  const attendanceHistory = getHistory(state, ownProps);
  return { attendanceHistory, groupId };
}

function mapDispatchToProps(dispatch) {
  return Object.assign({},
    bindActionCreators(attendanceActions, dispatch),
  );
}

function getHistory(state, ownProps) {
  const { timeZone } = groupActions.getCentre(state, ownProps.params.groupId);
  let attendanceHistory = state.get('rootReducer').get('attendanceHistory');
  if (! timeZone || ! ApiResponseHelper.hasSucceeded(attendanceHistory)) {
    return undefined;
  }

  attendanceHistory = attendanceHistory.data;
  return attendanceHistory.update('studentAttendanceHistories', (attendanceHistories) =>
      attendanceAccessors.updateDateByTimeZone(attendanceHistories, timeZone));
}

export default connect(mapStateToProps, mapDispatchToProps)(AttendanceHistory);



// WEBPACK FOOTER //
// ./containers/Group/Attendance/AttendanceHistory/component.jsx